<template>
    <v-row>
        <v-col cols="12" md="6">
            <div class="label">
                {{ $t('exercises.category') }}
            </div>
            <kimsa-select
                :items="categoriesOptions"
                :values="categories"
                @change="categories = $event"
                multiple color="secondary"
                bordered chip ref="categories"
            />
        </v-col>
        <v-col cols="12" md="6">
            <div class="label">
                {{ $t('exercises.type') }}
            </div>
            <small v-if="categories.length === 0">{{ $t('exercises.pick_category') }}</small>
            <kimsa-select
                :items="typesOptions"
                :values="types"
                @change="types = $event"
                multiple color="secondary"
                bordered chip ref="types"
            />
        </v-col>
    </v-row>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import KimsaSelect from "@/components/common/inputs/KimsaSelect";

export default {
    name: "ExerciseTypesPicker",
    components: {KimsaSelect},
    props: {
        defaultCategories: {
            type: Array,
            default: () => []
        },
        defaultTypes: {
            type: Array,
            default: () => []
        },
        forceValue: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            categories: [],
            types: []
        }
    },
    computed: {
        ...mapState(['categoriesOptions']),
        typesOptions(vm = this) {
            if (vm.categories.length === 0) return []
            let typesOptions = []
            vm.categoriesOptions.forEach(category => {
                if (vm.categories.includes(category.name)) typesOptions.push(...category.types)
            })
            typesOptions = typesOptions.map(type => {
                return {
                    name: type,
                    value: type,
                }
            })
            // Remove duplicates
            let hash = {}
            return typesOptions.filter(type => hash[type.value] ? false : hash[type.value] = true).sort(function (a, b) {
                if (a.name < b.name) return -1
                if (a.name > b.name) return 1
                return 0
            });
        }
    },
    async mounted() {
        const vm = this
        if (vm.categoriesOptions.length === 0) await vm.fetchExerciseCategories()
        vm.setDefaults()
    },
    methods: {
        ...mapActions(['fetchExerciseCategories']),
        reset() {
            const vm = this
            vm.$refs.categories.reset()
            vm.$refs.types.reset()
            vm.categories = []
            vm.types = []
        },
        setDefaults() {
            const vm = this
            if (vm.defaultCategories.length > 0 || vm.forceValue) vm.categories = vm.defaultCategories
            if (vm.defaultTypes.length > 0 || vm.forceValue) vm.types = vm.defaultTypes
        }
    },
    watch: {
        defaultCategories() {
            this.setDefaults()
        },
        defaultTypes() {
            this.setDefaults()
        },
        categories(val) {
            const vm = this
            vm.$emit('change:categories', val)
        },
        types(val) {
            const vm = this
            vm.$emit('change:types', val)
        }
    }
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #333333;
    font-weight: 700;
    margin-bottom: 12px;
}

</style>